var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAcasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_2120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500854,
    y: 0.272461,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50085 19.2725V10.2725C4.50085 9.95579 4.57169 9.65579 4.71335 9.37246C4.85502 9.08913 5.05085 8.85579 5.30085 8.67246L11.3009 4.17246C11.6509 3.90579 12.0509 3.77246 12.5009 3.77246C12.9509 3.77246 13.3509 3.90579 13.7009 4.17246L19.7009 8.67246C19.9509 8.85579 20.1467 9.08913 20.2884 9.37246C20.43 9.65579 20.5009 9.95579 20.5009 10.2725V19.2725C20.5009 19.8225 20.305 20.2933 19.9134 20.685C19.5217 21.0766 19.0509 21.2725 18.5009 21.2725H6.50085C5.95085 21.2725 5.48002 21.0766 5.08835 20.685C4.69669 20.2933 4.50085 19.8225 4.50085 19.2725ZM6.50085 19.2725H18.5009V10.2725L12.5009 5.77246L6.50085 10.2725V19.2725Z",
    fill: "#7E8488"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcasa);
export default __webpack_public_path__ + "static/media/icon_acasa.017b81aaf64e7a5b619ff00a0a13c3e2.svg";
export { ForwardRef as ReactComponent };